/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'coating-scratch': {
    width: 115,
    height: 115,
    viewBox: '0 0 115 115',
    data: `<defs><clipPath id="svgicon_coating-scratch_a"><path pid="0" d="M0 0h115v115H0z"/></clipPath></defs><g clip-path="url(#svgicon_coating-scratch_a)"><path pid="1" d="M.535 32.107s3.177 64.426 37.636 68.818 52.055 0 62.32-18.3 14.663-36.85 13.931-46.368-8.066-18.791-39.1-22.207S-.932 11.363.535 32.107z" _fill="#fff" _stroke="currentColor" stroke-miterlimit="10"/><path pid="2" d="M19.365 54.64L89.93 29.812M32.625 61.961c1.861-1.627 4.3-2.4 6.674-3.114q22-6.648 44.441-11.725M43.919 71.416q21.634-6.977 42.81-15.274M36.604 86.029c11.195-4.265 23.427-5.16 34.757-9.052" _fill="none" _stroke="currentColor" stroke-miterlimit="10"/></g>`
  }
})
/* tslint:enable */
